// import {
//   useUsers,
//   useProjects,
//   useChats,
//   useResearch,
//   useSessions,
//   useUserLogs,
// } from "../api/api-hooks";
// import { useMemo } from "react";

// export const useAdminData = () => {
//   const {
//     data: users,
//     isLoading: isUsersLoading,
//     error: usersError,
//     refetch: refetchUsers,
//   } = useUsers();

//   const {
//     data: projects,
//     isLoading: isProjectsLoading,
//     error: projectsError,
//   } = useProjects();

//   const {
//     data: chats,
//     isLoading: isChatsLoading,
//     error: chatsError,
//   } = useChats();

//   const {
//     data: researches,
//     isLoading: isResearchLoading,
//     error: researchError,
//   } = useResearch();

//   const {
//     data: sessions,
//     isLoading: isSessionLoading,
//     error: sessionsError,
//   } = useSessions();

//   const {
//     data: userLogs,
//     isLoading: isUserLogsLoading,
//     error: userLogsError,
//     refetch: refetchUserLogs,
//   } = useUserLogs();

//   const isLoading = useMemo(
//     () =>
//       isUsersLoading &&
//       isProjectsLoading &&
//       isChatsLoading &&
//       isResearchLoading &&
//       isSessionLoading,
//     [
//       isUsersLoading,
//       isProjectsLoading,
//       isChatsLoading,
//       isResearchLoading,
//       isSessionLoading,
//     ]
//   );

//   const error = useMemo(
//     () =>
//       usersError &&
//       projectsError &&
//       chatsError &&
//       researchError &&
//       sessionsError &&
//       null,
//     [usersError, projectsError, chatsError, researchError, sessionsError]
//   );

//   const activeChats = useMemo(() => {
//     if (!Array.isArray(chats?.items)) return [];
//     return chats?.items?.filter(
//       (chat: any) => chat?.status?.toLowerCase() === "active"
//     );
//   }, [chats]);

//   // const activeUsers = useMemo(() => {
//   //   if (!Array.isArray(users)) return [];
//   //   return users?.filter((user: any) => user?.status === "Active");
//   // }, [users]);

//   const activeUsers = useMemo(() => {
//     if (!Array.isArray(users?.items)) return [];
//     return users?.items.filter((user: any) => user?.status === "Active");
//   }, [users]);

//   const inactiveUsers = useMemo(() => {
//     if (!Array.isArray(users?.items)) return [];
//     return users?.items?.filter((user: any) => user?.status === "InActive");
//   }, [users]);

//   const activeSessions = useMemo(() => {
//     if (!Array.isArray(sessions?.Sessions?.items)) return [];
//     return sessions?.Sessions?.filter(
//       (session: any) => session?.status === "Active"
//     );
//   }, [sessions]);

//   const refetchFunctions = {
//     // refetchAll,
//     refetchUsers,
//     // refetchProjects,
//     // refetchChats,
//     // refetchResearches,
//     // refetchSessions,
//     refetchUserLogs,
//   };

//   // const isNewUsers = [
//   //   "last_24_hours",
//   //   "last_7_days",
//   //   "last_15_days",
//   //   "last_30_days",
//   // ].includes(selectedValue.value);

//   return {
//     users,
//     projects,
//     chats,
//     userLogs,
//     researches,
//     sessions,
//     activeChats,
//     activeUsers,
//     activeSessions,
//     inactiveUsers,
//     isLoading,
//     error,
//     loadingStates: {
//       isUsersLoading,
//       isProjectsLoading,
//       isChatsLoading,
//       isResearchLoading,
//       isSessionLoading,
//       isUserLogsLoading,
//     },
//     errorStates: {
//       usersError,
//       projectsError,
//       chatsError,
//       researchError,
//       sessionsError,
//       userLogsError,
//     },
//     refetchFunctions,
//   };
// };

import {
  useUsersPage,
  useProjectsPage,
  useChatsPage,
  useSessionsPage,
  useUserLogs,
  useFeedbackPage,
} from "../api/api-hooks";
import { useMemo } from "react";
import useCommonStore from "../store/CommonStore";
import { getDateRangeFromSelectedValue } from "../common/Constants";
import { usePagination } from "../features/hooks/usePagination";

export const useAdminData = () => {
  const { selectedValue } = useCommonStore();
  const dateRange = getDateRangeFromSelectedValue(selectedValue);
  const { pageIndex, pageSize } = usePagination();

  const isAllData = dateRange?.isAllData ?? false;
  const startDate = isAllData ? undefined : dateRange?.startDate ?? "";
  const endDate = isAllData ? undefined : dateRange?.endDate ?? "";

  const {
    data: users,
    isLoading: isUsersLoading,
    error: usersError,
    refetch: refetchUsers,
  } = useUsersPage(pageIndex + 1, pageSize, startDate, endDate, "", isAllData);

  const {
    data: projects,
    isLoading: isProjectsLoading,
    error: projectsError,
  } = useProjectsPage(pageIndex + 1, pageSize, startDate, endDate, isAllData);

  const {
    data: chats,
    isLoading: isChatsLoading,
    error: chatsError,
  } = useChatsPage(
    pageIndex + 1,
    pageSize,
    startDate,
    endDate,
    "rolesgpt",
    "",
    isAllData
  );

  const {
    data: hrChats,
    isLoading: isHrChatsLoading,
    error: hrChatsError,
  } = useChatsPage(
    pageIndex + 1,
    pageSize,
    startDate,
    endDate,
    "HR App",
    "",
    isAllData
  );

  const {
    data: sessions,
    isLoading: isSessionLoading,
    error: sessionsError,
  } = useSessionsPage(pageIndex + 1, pageSize, startDate, endDate, isAllData);

  const {
    data: feedbacks,
    isLoading: isFeedbackLoading,
    error: feedbackError,
  } = useFeedbackPage(pageIndex + 1, pageSize, startDate, endDate, isAllData);

  const {
    data: activeUsers,
    isLoading: isActiveUsersLoading,
    error: activeUsersError,
  } = useUsersPage(
    pageIndex + 1,
    pageSize,
    startDate,
    endDate,
    "true",
    isAllData
  );

  const {
    data: inactiveUsers,
    isLoading: isInactiveUsersLoading,
    error: inactiveUsersError,
  } = useUsersPage(
    pageIndex + 1,
    pageSize,
    startDate,
    endDate,
    "false",
    isAllData
  );

  const {
    data: userLogs,
    isLoading: isUserLogsLoading,
    error: userLogsError,
    refetch: refetchUserLogs,
  } = useUserLogs();

  const isLoading = useMemo(
    () =>
      isUsersLoading ||
      isProjectsLoading ||
      isChatsLoading ||
      isSessionLoading ||
      isUserLogsLoading ||
      isActiveUsersLoading ||
      isFeedbackLoading ||
      isInactiveUsersLoading ||
      isHrChatsLoading,
    [
      isUsersLoading,
      isProjectsLoading,
      isChatsLoading,
      isSessionLoading,
      isUserLogsLoading,
      isFeedbackLoading,
      isActiveUsersLoading,
      isInactiveUsersLoading,
      isHrChatsLoading,
    ]
  );

  const error = useMemo(
    () =>
      usersError ||
      projectsError ||
      chatsError ||
      sessionsError ||
      userLogsError ||
      feedbackError ||
      activeUsersError ||
      inactiveUsersError ||
      hrChatsError ||
      null,
    [
      usersError,
      projectsError,
      chatsError,
      sessionsError,
      userLogsError,
      feedbackError,
      activeUsersError,
      inactiveUsersError,
      hrChatsError,
    ]
  );

  // const activeUsers = useMemo(() => {
  //   return users?.items?.filter((user: any) => user?.status === "Active") || [];
  // }, [users]);

  // const inactiveUsers = useMemo(() => {
  //   return (
  //     users?.items?.filter((user: any) => user?.status === "InActive") || []
  //   );
  // }, [users]);

  const activeChats = useMemo(() => {
    return (
      chats?.items?.filter(
        (chat: any) => chat?.status?.toLowerCase() === "active"
      ) || []
    );
  }, [chats]);

  const activeSessions = useMemo(() => {
    return (
      sessions?.Sessions?.filter(
        (session: any) => session?.status === "Active"
      ) || []
    );
  }, [sessions]);

  const refetchFunctions = {
    refetchUsers,
    refetchUserLogs,
  };

  return {
    users,
    projects,
    chats,
    hrChats,
    sessions,
    userLogs,
    feedbacks,
    activeUsers,
    inactiveUsers,
    activeChats,
    activeSessions,
    isLoading,
    error,
    loadingStates: {
      isUsersLoading,
      isProjectsLoading,
      isChatsLoading,
      isSessionLoading,
      isUserLogsLoading,
      isFeedbackLoading,
      isActiveUsersLoading,
      isInactiveUsersLoading,
      isHrChatsLoading,
    },
    errorStates: {
      usersError,
      projectsError,
      chatsError,
      sessionsError,
      userLogsError,
      feedbackError,
      activeUsersError,
      inactiveUsersError,
      hrChatsError,
    },
    refetchFunctions,
  };
};
